import { TOptions } from "i18next";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/atoms-react/button/Button.react";
import { Base } from "@/atoms-react/text/Text.react";
import CopyButton from "@/views/kypay/components/button-copy/index.react";
import { SuccessCard } from "../atoms/SuccessCard";

type CompanyPayment_BankTransferProps = {
  amount: string;
  iban: string;
  bic: string;
  account: string;
  address: string;
};

export const CompanyPaymentBankTransfer = ({
  account,
  address,
  iban,
  bic,
  amount
}: CompanyPayment_BankTransferProps) => {
  const { t } = useTranslation(["pass", "error"]);
  const tr = (key: string, options?: TOptions) => t(`companyPayment.bank_transfer.${key}`, options);
  const [success, setSuccess] = useState<boolean>(false);

  const CopyLine = ({ label, value }: { label: string; value: string }) => (
    <div className="flex items-baseline justify-between">
      <div className="flex flex-1 flex-row items-center items-baseline gap-2">
        <div className="w-1/4 dark:text-white">{label}:</div>
        <div className="w-3/4 pl-5 xs:pl-0 font-bold text-black dark:text-white">{value}</div>
      </div>
      <CopyButton
        text={value}
        iconClassName={"text-primary dark:text-white"}
        succesMessage={`${label} ${tr("copied_item")}`}
      />
    </div>
  );

  return (
    <div>
      <div className="my-5 flex justify-center rounded-tl-md rounded-br-md border border-primary bg-primary/10 px-5 py-8 dark:bg-primary-700 dark:text-white">
        <div className="flex flex-col items-center gap-8 text-slate-900">
          <Base className="text-center text-slate-900">{tr("header")}</Base>

          <div className="flex flex-col gap-2">
            <CopyLine label={tr("labels.account")} value={account} />
            <CopyLine label={tr("labels.address")} value={address} />
            <CopyLine label={tr("labels.iban")} value={iban} />
            <CopyLine label={tr("labels.bic")} value={bic} />
            <CopyLine label={tr("labels.amount")} value={amount} />
          </div>

          {!success && (
            <Button className="w-auto" onClick={() => setSuccess(true)}>
              {tr("cta")}
            </Button>
          )}

          <Base className="xs:w-3/4 text-center text-slate-900">{tr("footer")}</Base>
        </div>
      </div>

      {success && <SuccessCard text={tr("successMessage")} />}
    </div>
  );
};
